// Constants
import { CONFIRM_MESSAGE_CONFIG } from '@shared/constants';

// UI
import { Button } from '@shared/ui';

// Utils
import { combineClasses } from '@shared/utils';
type ConfirmationActionModalProps = {
  message: string;
  onCancel: () => void;
  onSubmit: () => void;
  isLoading?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  hasShadow?: boolean;
  className?: string;
};
export const ConfirmationActionModal = ({
  message,
  onCancel,
  onSubmit,
  isLoading = false,
  hasShadow = true,
  confirmLabel = CONFIRM_MESSAGE_CONFIG.DEFAULT_CONFIRM_LABEL,
  cancelLabel,
  className
}: ConfirmationActionModalProps) => <div className={combineClasses(className)} data-sentry-component="ConfirmationActionModal" data-sentry-source-file="ConfirmationActionModal.tsx">
    <div className={`${hasShadow ? 'bg-background border border-frost-250 p-5 rounded-md shadow-md' : ''}`}>
      <div className="flex flex-col justify-center flex-1">
        <p className="text-3xs leading-5">{message}</p>
      </div>
      <div className={`w-full grid sm:gap-4 ${cancelLabel ? 'sm:grid-cols-2' : 'sm:grid-cols-1'}`}>
        <Button aria-label="Save members" className="bg-primary-700 text-3xs hover:bg-primary-700/80 mt-3 disabled:bg-frost-250 disabled:text-muted-foreground" type="button" disabled={isLoading} isLoading={isLoading} onClick={onSubmit} data-sentry-element="Button" data-sentry-source-file="ConfirmationActionModal.tsx">
          {confirmLabel}
        </Button>
        {cancelLabel && <Button className="bg-gray-400 text-3xs hover:bg-gray-400/80 mt-3 disabled:bg-frost-250 disabled:text-muted-foreground" type="button" onClick={onCancel} disabled={isLoading}>
            {cancelLabel}
          </Button>}
      </div>
    </div>
  </div>;